import firebase from "firebase/compat/app";
import "firebase/compat/functions";

/**
 * Atomically claim a visit TCI for the patient or clinician party.
 * Loser of a race gets alreadyClaimed: true with the winner's status.
 */
export async function claimVisitTci({ clinicId, visitId, tciId, party }) {
  const fn = firebase.functions().httpsCallable("claimVisitTci");
  const { data } = await fn({ clinicId, visitId, tciId, party });
  return data;
}

export async function completeVisitTci({ clinicId, visitId, tciId }) {
  const fn = firebase.functions().httpsCallable("completeVisitTci");
  const { data } = await fn({ clinicId, visitId, tciId });
  return data;
}
